import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import './App.css'
import LoadingBackdrop from 'components/LoadingBackdrop'
import Toast from 'components/Toast'
import Routes from 'routes'
import { selectShowLoadingBackdrop } from 'store/slices/appMiscSlice'
import { selectUserMiscLoading } from 'store/slices/userSlice'
import { isLexusUrl } from 'utils/utils'

function getFaviconEl() {
  return document.getElementById("favicon");
}

const routeTitles = [
  { path: 'picture-explanation', title: ' - Spiegazione immagine' },
  { path: 'recap', title: ' - Riepilogo ordine' },
  { path: 'choose-option', title: ' - Scelta opzione' },
  { path: 'login', title: ' - Login' },
  { path: 'registration', title: ' - Registrazione' },
  { path: 'password-recovery', title: ' - Recupero password' },
  { path: 'email-submission', title: ' - Invio email' },
  { path: 'phone-submission', title: ' - Invio numero di telefono' },
  { path: 'personal-info-submission', title: ' - Dati personali' },
  { path: 'password-submission', title: ' - Scelta password' },
  { path: 'homepage', title: ' - Area cliente' },
  { path: 'profile', title: ' - Dati personali' },
  { path: 'update/email', title: ' - Cambio email' },
  { path: 'update/phone', title: ' - Cambio numero di telefono' },
  { path: 'update/password', title: ' - Cambio password' },
  { path: 'pay-instalment', title: ' - Paga rata' },
  { path: 'payments-made/detail', title: ' - Dettaglio pagamenti effettuati' },
  { path: 'payments-made', title: ' - Pagamenti effettuati' },
  { path: 'payments-situation', title: ' - Situazione pagamenti' },
  { path: 'informative-documents', title: ' - Documenti informativi' },
  { path: 'direct-payment', title: ' - Pagamento diretto' },
  { path: 'split-payment-overview', title: ' - Panoramica rateizzazione' },
  { path: 'split-payment', title: ' - Rateizzazione' },
  { path: 'thank-you-financial', title: ' - Grazie - finanziamento' },
  { path: 'thank-you', title: ' - Grazie' },
  { path: 'error', title: ' - Errore' },
  { path: 'ko-financial', title: ' - Pagamento non riuscito - finanziamento' },
  { path: 'ko', title: ' - Pagamento non riuscito' },
  { path: 'payment-method', title: ' - Metodo di pagamento' }
]

const App = () => {
  const loadingAppMisc = useSelector(selectShowLoadingBackdrop)
  const loadingUserMisc = useSelector(selectUserMiscLoading)
  const location = useLocation()


  useEffect(() => {
    const url = window.location.href
    const pathname = location.pathname

    const matched = routeTitles.find(({ path }) => pathname.includes(path))
    const baseTitle = matched?.title || ''

    isLexusUrl(url).then(isLexus => {
      document.title = `${isLexus ? 'Lexus Easy Pay' : 'Toyota Easy Pay'}${baseTitle}`
      const favicon = getFaviconEl()
      if (favicon) {
        favicon.setAttribute('href', isLexus ? '/favicon-Lexus.ico' : '/favicon.ico')
      }
    })
  }, [location.pathname])

  return (
    <div>
      <a href="#maincontent" className="sr-only">Salta al contenuto principale</a>
      <Toast />
      {(loadingAppMisc || loadingUserMisc) && <LoadingBackdrop />}
      <Routes />
    </div>
  )
}

export default App
